
import { Card, CardContent } from "@/components/ui/card";
import { HandHeart, Users, Globe, Star } from "lucide-react";

const PartnershipValues = () => {
  return (
    <section className="py-16 bg-white/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-teedee-blue mb-4">Why We Partner</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Together, we create stronger educational experiences and positive community impact.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-teedee-blue/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <HandHeart className="h-8 w-8 text-teedee-blue" />
            </div>
            <h3 className="text-lg font-bold text-teedee-blue mb-3">Shared Mission</h3>
            <p className="text-gray-600 text-sm">
              Partnering with organizations that share our commitment to children's education and well-being.
            </p>
          </div>

          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-bobo-green/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <Users className="h-8 w-8 text-bobo-green" />
            </div>
            <h3 className="text-lg font-bold text-bobo-green mb-3">Community Impact</h3>
            <p className="text-gray-600 text-sm">
              Creating positive change in the Cayman Islands community through collaborative efforts.
            </p>
          </div>

          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-brand-purple/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <Globe className="h-8 w-8 text-brand-purple" />
            </div>
            <h3 className="text-lg font-bold text-brand-purple mb-3">Cultural Preservation</h3>
            <p className="text-gray-600 text-sm">
              Working together to preserve and celebrate Cayman Islands heritage for future generations.
            </p>
          </div>

          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-golden-orange/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <Star className="h-8 w-8 text-golden-orange" />
            </div>
            <h3 className="text-lg font-bold text-golden-orange mb-3">Excellence</h3>
            <p className="text-gray-600 text-sm">
              Striving for the highest quality in educational content and community service.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipValues;
